import { ButtonHTMLAttributes } from "react";
import styles from "./styles.module.scss";
import { ClipLoader } from "react-spinners";

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  title: string;
  icon?: React.ReactNode;
  titleColor?: string;
  isLoading?: boolean;
  width?: string;
};

const IconButton = ({
  title,
  icon,
  titleColor,
  isLoading,
  width,
  ...props
}: IconButtonProps) => {
  return (
    <button
      className={styles.wrapper}
      {...props}
      style={{ width }}
      disabled={isLoading || props.disabled}
    >
      {icon}
      {isLoading ? (
        <ClipLoader color={titleColor} loading={isLoading} size={14} />
      ) : (
        <span style={{ color: titleColor }}>{title}</span>
      )}
    </button>
  );
};

export default IconButton;
